import React, { FC } from 'react';
import { Col, Modal, Row, Select, Spin } from 'antd';
import { AntForm } from '@shared/styled/ant-form';
import { Formik, FormikProps } from 'formik';
import { useNavigate } from 'react-router-dom';
import { TextField, SelectField } from '@shared/modules/form';
import { useCashRegisterForm, CashRegisterFormValues, useCurrencies } from '../hooks';

const CreateCashRegisterForm: FC<FormikProps<CashRegisterFormValues> & { id?: string }> = ({ handleSubmit, isSubmitting, id }) => {
  const navigate = useNavigate();

  const { data: currencies = [] } = useCurrencies();

  return (
    <Modal
      open={true}
      onOk={() => handleSubmit()}
      onCancel={() => navigate('/cash-flow/cash-registers')}
      confirmLoading={isSubmitting}
      title={!id ? 'Kassa əməliyyatı əlavə et' : 'Kassa əməliyyatında düzəliş et'}
    >
      <AntForm layout="vertical" component="div" size="large">
        <Row gutter={[24, 0]}>
          <Col xs={24} lg={12}>
            <TextField name="name" item={{ label: 'Ad' }} input={{ placeholder: 'Kassanın adını daxil edin...' }} />
          </Col>
          <Col xs={24} lg={12}>
            <TextField name="amount" format="decimal" item={{ label: 'Balans' }} input={{ disabled: !!id, placeholder: 'Balansı daxil edin...' }} />
          </Col>
          <Col xs={24}>
            <SelectField name="currencyId" item={{ label: 'Valyuta' }} input={{ placeholder: 'Valyuta seçin...' }}>
              {currencies.map((c) => (
                <Select.Option key={c.id} value={c.id.toString()}>
                  {c.name}
                </Select.Option>
              ))}
            </SelectField>
          </Col>
        </Row>
      </AntForm>
    </Modal>
  );
};

export const CreateCashRegister: FC = () => {
  const { initialValues, onSubmit, id, isLoading } = useCashRegisterForm();

  if (isLoading) {
    return (
      <Modal open={true} footer={null} closable={false}>
        <Spin style={{ display: 'block', padding: '40px 0', textAlign: 'center' }} />
      </Modal>
    );
  }

  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit} enableReinitialize={true}>
      {(f) => <CreateCashRegisterForm {...f} id={id} />}
    </Formik>
  );
};
